const errorStyle = { display: 'block' };
const ErrorMessage = ({ message }) => {
  return (
    <span className="invalid-feedback" style={errorStyle}>
      {message}
    </span>
  );
};

const SuccessMessage = () => {
  return (
    <p className="alert alert-success text-center">
      Thank you! Your message was successfully sent.
    </p>
  );
};

const FailMessage = () => {
  return (
    <p className="alert alert-danger text-center">
      Sorry something went wrong, please email us at{' '}
      <a href="mailto:support@CollegeRecruiter.com">support@CollegeRecruiter.com</a> if you continue
      to see this error.
    </p>
  );
};

import Image from 'next/image';
import loaderImg from '../../../public/images/loading_128.gif';
const loaderStyle = { marginTop: '80px', marginBottom: '75px' };
const LoaderImage = () => {
  return (
    <div className="text-center col-md-6 offset-md-3">
      <div style={loaderStyle}>
        <Image priority width={128} height={128} alt="Loading..." src={loaderImg} />
      </div>
    </div>
  );
};

module.exports = { ErrorMessage, SuccessMessage, FailMessage, LoaderImage };
